<template>
  <div class="my-layout-box">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :placeholderTitle='placeholderTitle'
      :listMap="listMap">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getOrderBalance } from "~/api/finance";
export default {
  name: "OrderBalanceView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: false,
      listMap: itemsData,
      placeholderTitle: '请输入单号'
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      sendData.OrderNo = searchData.value;
      const list = await getOrderBalance(sendData);
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    }
  }
};
</script>

<style lang="less" scope></style>
